import { render, staticRenderFns } from "./SelectorPoints.vue?vue&type=template&id=43f56288&"
import script from "./SelectorPoints.vue?vue&type=script&lang=js&"
export * from "./SelectorPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports